import {
	Component,
	ViewEncapsulation,
	Input,
	ContentChildren,
	QueryList,
	AfterContentInit
} from "@angular/core";
import { IdService } from "../../shared/services/id.service";
import { SnackbarComponent } from "../snackbar.component";

@Component({
	selector: "rbc-snackbar-container",
	templateUrl: "./snackbar-container.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None
})
export class SnackbarContainerComponent implements AfterContentInit {
	@Input() id: string;
	classes: string[] = [];

	@ContentChildren(SnackbarComponent) snackbars: QueryList<SnackbarComponent>;

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	ngAfterContentInit(): void {
		if (this.snackbars && this.snackbars.first) {
			const arr = this.snackbars.first.classGen();
			// add position classes to array
			this.classes.push(arr[0], arr[1]);
		}
	}
}
